<div *ngIf="regProgress" class="svg-loader"></div>
<form (ngSubmit)="onSubmit()" #f="ngForm">
  <div class="progressRibbon">
    <button type="button" class="close cancelBtn" typeof="button" aria-label="Close" mat-dialog-close>Close</button>
    <div class="mod-stepper-container">
      <div class="mod-stepper">
        <div class="stepper-cricle" [ngClass]="{ 'active-stepper': selectedStep === 0}">
          <div class="stepper-header">Configure Model</div>
          <div class="stepper-number">1</div>
        </div>
        <div class="stepper-bar"></div>
        <div class="stepper-cricle" [ngClass]="{ 'active-stepper': selectedStep === 1}">
          <div class="stepper-header">
            Configure Model Parameters
          </div>
          <div class="stepper-number">2</div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isVertical">
    <mat-horizontal-stepper (selectionChange)="configureStepChange($event)" labelPosition="bottom" [linear]="isLinear" (animationDone)="selectionChange(stepper.selectedIndex )" #stepper>
      <mat-step [stepControl]="firstFormGroup" label="Select Model">
        <ng-template matStepLabel>Configure Model</ng-template>
        <div class="float-right text-right d-flex">
          <button class="btn font-weight-bold nextBtn" matStepperNext type="button" [disabled]="validateFirstStep()">
            <mat-icon class="mat-icon-arrow">keyboard_arrow_right</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="step1Template"></ng-container>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup" label="configuration">
        <ng-template matStepLabel>Configure Model Parameters</ng-template>
        <div class="float-right text-right d-flex">
          <div>
            <button class="btn font-weight-bold prevBtn" matStepperPrevious>
              <mat-icon class="mat-icon-arrow">keyboard_arrow_left</mat-icon>
            </button>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="step2Template"></ng-container>
        <div class="stepperFooter clear d-flex justify-content-end">
          <ng-container *ngIf="isConfigureEdit">             
            <button class=" btn-primary btn" typeof="button" aria-label="Save" (click)="onSubmit()"
                    [disabled]="invalidStepTwo || (paramExist && authExist) || isClientAvailable || isSubscriptionAvailable ||
                  isSecretAvailable" type="button" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
              Save
            </button>
          </ng-container>
          <ng-container *ngIf="!isConfigureEdit">
            <button class=" btn-primary btn" typeof="button" aria-label="Save" (click)="onSubmit()"
                    [disabled]="invalidStepTwo || isClientAvailable || isSubscriptionAvailable ||
                  isSecretAvailable || disableSave()" type="button" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
              Save
            </button>
          </ng-container>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </ng-container>

  <ng-container *ngIf="isVertical">
    <mat-vertical-stepper [linear]="isLinear" #stepper>
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>Configure Model</ng-template>
        <ng-container *ngTemplateOutlet="step1Template"></ng-container>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <ng-template matStepLabel>Configure Model Parameters</ng-template>
        <ng-container *ngTemplateOutlet="step2Template"></ng-container>
      </mat-step>
    </mat-vertical-stepper>
  </ng-container>

  <ng-template #step1Template>
    <div class="modelRegistration">
      <div class="stepTwo">
        <div class="modelRegistrationPage">
          <form [formGroup]="configureModelForm">
            <div class="registrationFormGroup">
              <div class="form-group row mt-3 mx-3">
                <label for="modelType" class="col-2 mt-2 mandatory-field header heading2">
                  Model Type <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <select class="form-control select-btn" id="modelType" (change)="onModelTypeSelected($event)" required
                          formControlName="modelType" [ngClass]="{ 'readOnly': data.selectedData}">
                    <option [ngValue]="null" selected disabled>Configure Model Type</option>
                    <option *ngFor="let element of modelTypeList" [ngValue]="element">{{element}}</option>
                  </select>
                </div>
                <div class="col-6" *ngIf="isBasedType">
                  <div class="row">
                    <label for="modelBased" class="col-4 mt-2 mandatory-field header heading2">
                      Base Model <span class="text-danger star-danger">*</span>
                    </label>
                    <div class="col-8">
                      <select id="modelBased" (change)="onBasedModelSelected($event)" class="form-control select-btn" required
                              formControlName="modelBased" [ngClass]="{ 'readOnly': data.selectedData}">
                        <option [ngValue]="null" selected disabled>Select Base Model</option>
                        <option *ngFor="let element of modelBasedList" [ngValue]="element.value">{{element.viewValue}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row mt-3 mx-3">
                <label for="modelName" class="col-2 mt-2 mandatory-field header heading2">Model Name <span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="modelName" formControlName="modelName"
                         maxlength="30" required autocomplete="off" [formControl]="configureModelForm.get('modelName')" [matAutocomplete]="auto" [ngClass]="{ 'readOnly': data.selectedData}" />
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredModelList | async" [value]="option">
                      {{option}}
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <label for="modelVersion" class="col-2 mt-2 mandatory-field header heading2">Model Version <span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="modelVersion" (keyup)="onModelVersionFocusOut($event)" formControlName="modelVersion"
                         maxlength="30" required autocomplete="off" [ngClass]="{ 'readOnly': data.selectedData}" />
                  <div class="invalid-entry" *ngIf="modelVersionUsed">
                    This Model Version is already being used.
                  </div>
                </div>
              </div>
              <div class="form-group row mt-3 mx-3">
                <label for="modelUrl" class="col-2 mt-2 mandatory-field header heading2">API URL <span class="text-danger star-danger">*</span></label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="modelUrl" formControlName="modelUrl" required [ngClass]="{ 'readOnly': data.selectedData}" />
                  <div class="invalid-entry"
                       *ngIf="configureModelForm.get('modelUrl').invalid && (configureModelForm.get('modelUrl').dirty || configureModelForm.get('modelUrl').touched)">
                    <div class="invalid-entry" *ngIf="configureModelForm.get('modelUrl').errors?.required">
                      API URL is required.
                    </div>
                    <div class="invalid-entry" *ngIf="configureModelForm.get('modelUrl').errors?.pattern">
                      It should be a https URL.
                    </div>
                    <div class="invalid-entry" *ngIf="configureModelForm.get('modelUrl').errors?.cannotContainSpace">
                      API URL should not contain space.
                    </div>
                  </div>
                </div>

                <label for="authRequired" class="col-2 mt-2 mandatory-field header heading2">
                  OAuth Authentication
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <select class="form-control select-btn" id="authRequired" (change)="onOauthSelected($event)"
                          required formControlName="authRequired" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}">
                    <option [ngValue]="null" selected disabled>Select Oauth Authentication</option>
                    <option *ngFor="let element of oauthAuthenticationList" [ngValue]="element.authId">{{element.type}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret || isOauthManagedIdentity">
                <label for="subscriptionKey" class="col-2 mt-2 pr-1 mandatory-field header heading2">
                  Subscription Key Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="subscriptionKey" formControlName="subscriptionKey"
                         (change)="secretNameCheck('subscriptionKey',$event)" (keyup)="validateBeforeUpdate($event, subscriptionKey)"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('subscriptionKey')" 
                         [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}" />
                  <div class="invalid-entry" *ngIf="isSubscriptionAvailable">
                    Subscription Key is alredy in use.
                  </div>
                </div>
                <label for="subscriptionValue" class="col-2 mt-2 pr-1 mandatory-field header heading2">
                  Subscription Key Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="subscriptionValue" formControlName="subscriptionValue"
                         (keyup)="validateBeforeUpdate($event, subscriptionValue)" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('subscriptionValue')" />
                </div>
              </div>
              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret">

                <label for="clientIdName" class="col-2 mt-2 mandatory-field header heading2">
                  Client Id Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="clientIdName" formControlName="clientIdName"
                         (change)="secretNameCheck('clientKey',$event)" (keyup)="validateBeforeUpdate($event,  clientIdName)"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('clientIdName')"
                         [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}" />
                  <div class="invalid-entry" *ngIf="isClientAvailable">
                    Client Id is alredy in use.
                  </div>
                </div>
                <label for="clientIdNameValue" class="col-2 mt-2 mandatory-field header heading2">
                  Client Id Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="clientIdNameValue" formControlName="clientIdNameValue"
                         (keyup)="validateBeforeUpdate($event, clientIdNameValue)" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('clientIdNameValue')" />
                </div>
              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret">

                <label for="secretName" class="col-2 mt-2 mandatory-field header heading2">
                  Secret Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="secretName" formControlName="secretName"
                         (change)="keyUniqueCheck('secretKey',$event)" (keyup)="validateBeforeUpdate($event, secretName)"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('secretName')"
                         [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}" />
                  <div class="invalid-entry" *ngIf="isSecretAvailable">
                    Secret name is alredy in use.
                  </div>
                </div>

                <label for="secretNameValue" class="col-sm-2 mt-2 mandatory-field header heading2">
                  Secret Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="secretNameValue" formControlName="secretNameValue"
                         (keyup)="validateBeforeUpdate($event, secretNameValue)" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('secretNameValue')" />
                </div>
              </div>

              <div class="form-group row mt-3 mx-3" *ngIf="isOauthClientAndSecret || isOauthManagedIdentity">

                <label for="scopeKeyName" class="col-2 mt-2 mandatory-field header heading2">
                  Scope Key Name
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="scopeKeyName" formControlName="scopeKeyName"
                         (change)="keyUniqueCheck('scopeKeyName',$event)" (keyup)="validateBeforeUpdate($event, scopeKeyName)"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('scopeKeyName')"
                         [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}" />
                  <div class="invalid-entry" *ngIf="isScopeAvailable">
                    Scope Key is alredy in use.
                  </div>
                </div>
                <label for="scopeKeyValue" class="col-2 mt-2 mandatory-field header heading2">
                  Scope Key Value
                  <span class="text-danger star-danger">*</span>
                </label>
                <div class="col-4">
                  <input type="text" class="form-control largeText" id="scopeKeyValue" formControlName="scopeKeyValue"
                         (keyup)="validateBeforeUpdate($event, scopeKeyValue)" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}"
                         maxlength="50" required autocomplete="off" [formControl]="configureModelForm.get('scopeKeyValue')" />
                </div>
              </div>

            </div>
          </form>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </ng-template>

  <ng-template #step2Template>
    <div class="modelRegistration">
      <div class="stepTwo">
        <div class="configureParam modelRegistrationPage"
             *ngIf="modelData.inputParameters.length > 0 && !regProgress">
          <div class="configModelTypeContainer">
            <div (click)="selectParamType('input', true)" (keydown)="selectParamType('input', true);"
                 [ngClass]="{ 'activeModel': isInputParameters}" class="configModelType">
              <div class="">Input Parameters</div>
            </div>
            <div (click)="selectParamType('output', false)" (keydown)="selectParamType('output', false);"
                 [ngClass]="{ 'activeModel': !isInputParameters}" class="configModelType">
              <div class="">Output Parameters</div>
            </div>
          </div>
          <div class="paramsContainer">
            <div class="panel-div" *ngIf="isInputParameters">
              <mat-accordion class="config_accordion">
                <div class="d-flex table-container fixed-height">
                  <mat-table [dataSource]="inputParameters" matSort matSortActive="parameterName" matSortDirection="asc" matSortDisableClear>
                    <ng-container matColumnDef="parameterName">
                      <mat-header-cell *matHeaderCellDef class="heading2"></mat-header-cell>
                      <mat-cell *matCellDef="let element; let rowIndex = index" class="regularText inputoutputboxsize">
                        <input (keyup)="validateParameter($event, rowIndex, modelData)" class="form-control" [ngModelOptions]="{standalone: true}" 
                        [(ngModel)]="modelData.inputParameters[rowIndex].parameterName" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}">
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <mat-header-cell *matHeaderCellDef class="heading2 matAction"></mat-header-cell>
                      <mat-cell *matCellDef="let element; let i=index" class="regularText inputoutputiconsize">
                        <button class="deleteIcon pointer" matTooltip="Delete" mat-icon-button (click)="deleteModel(i)" *ngIf="i <= inputParameters.data.length" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
                          <mat-icon class="action-icon-delete action-icon-common"></mat-icon>
                        </button>
                        <button class="deleteIcon pointer" matTooltip="Add" mat-icon-button *ngIf="displayAddParameters(i)" (click)="addNewParameter()" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
                          <mat-icon class="action-icon-add action-icon-common"></mat-icon>
                        </button>
                      </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
                    <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
                  </mat-table>
                </div>
              </mat-accordion>
            </div>

            <div class="panel-div" *ngIf="!isInputParameters">
              <mat-accordion class="config_accordion">
                <div class="d-flex table-container fixed-height">
                  <mat-table [dataSource]="outputParameters" matSort matSortActive="parameterName" matSortDirection="asc" matSortDisableClear>
                    <ng-container matColumnDef="parameterName">
                      <mat-header-cell *matHeaderCellDef class="heading2"></mat-header-cell>
                      <mat-cell *matCellDef="let element let rowIndex = index" class="regularText inputoutputboxsize">
                        <input (keyup)="validateParameter($event, rowIndex, modelData)" class="form-control" [ngModelOptions]="{standalone: true}" 
                        [(ngModel)]="modelData.outputParameters[rowIndex].parameterName" [ngClass]="{ 'readonly': data.modelAction === 'viewModel'}">
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <mat-header-cell *matHeaderCellDef class="heading2 matAction"></mat-header-cell>
                      <mat-cell *matCellDef="let element; let i=index" class="regularText inputoutputiconsize">
                        <button class="deleteIcon pointer" (click)="deleteModel(i)" matTooltip="Delete" *ngIf="i <= outputParameters.data.length" mat-icon-button [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
                          <mat-icon class="action-icon-delete action-icon-common"></mat-icon>
                        </button>
                        <button class="deleteIcon pointer" matTooltip="Add" mat-icon-button *ngIf="displayAddParameters(i)" (click)="addNewParameter()" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
                          <mat-icon class="action-icon-add action-icon-common"></mat-icon>
                        </button>
                      </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
                    <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
                  </mat-table>
                </div>
              </mat-accordion>
            </div>
          </div>
        </div>

        <div class="noInputOutputParam" *ngIf="!regProgress && modelData.inputParameters.length === 0">
          {{noInputOutputParam}}
        </div>
      </div>
    </div>
  </ng-template>
</form>
